export const RESPONSE_LOAD_OK = "RESPONSE_LOAD_OK";

function scheduleReceive(json) {
    let shedules = [json.schedules[0].data.schedules || []]
    let dates = [json.schedules[0].data.dates]
    let cabinetName = json.schedules.map(schedulesItem => {return { cabinetName: schedulesItem.cabinetName, cabinetId: schedulesItem.cabinetId}})
    if(json.schedules.length > 1){
        shedules = json.schedules.map(scheduleItem => {return scheduleItem.data.schedules})
        dates = json.schedules.map(scheduleItem => {return scheduleItem.data.dates})
    }
    return {
        type: RESPONSE_LOAD_OK,
        dates: dates,
        schedules: shedules,
        offset: json.api.offset,
        id: json.api.id,
        gender: json.api.gender,
        cabinetId: json.schedules[0].cabinetId,
        cabinetName: cabinetName,
    }
}

export function Load(offset = 0, id = 0, gender = "") {
    return (dispatch) => {
        fetch(`/api/get-schedule?id=${id}&offset=${offset}&gender=${gender}`)
            .then(
                function(response) {
                    if (response.status !== 200) {
                        dispatch({
                            type: 'SCHEDULE_LOAD_FAIL',
                            payload: {
                                error_code: response.status
                            }
                        });
                    }
                    response.json().then(function(data) {
                        const editData = {
                            api: {
                                offset: offset,
                                id: id,
                                gender: gender,
                            },
                            schedules: data
                        }
                        return dispatch(scheduleReceive(editData));
                        // dispatch({
                        //     type: 'RESPONSE_LOAD_OK',
                        //     payload: {
                        //         data: data,
                        //         offset: offset
                        //     }
                        // });
                    });
                }
            )
            .catch(function(err) {
                dispatch({
                    type: 'SCHEDULE_PARSE_ERROR',
                    payload: {
                        error: err
                    }
                });
            });
    }
}



// WEBPACK FOOTER //
// frontend/src/actions/Appointment.js